import * as React from 'react'

const SvgLetterIcon = (props) => {
  const stroke = props?.color ? props?.color : '#667085'
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.16602 3.83331L7.97012 8.59618C8.52109 8.98187 8.79658 9.17471 9.09624 9.2494C9.36093 9.31538 9.63777 9.31538 9.90246 9.2494C10.2021 9.17471 10.4776 8.98187 11.0286 8.59618L17.8327 3.83331M5.16602 14.6666H13.8327C15.2328 14.6666 15.9329 14.6666 16.4677 14.3942C16.9381 14.1545 17.3205 13.772 17.5602 13.3016C17.8327 12.7668 17.8327 12.0668 17.8327 10.6666V5.33331C17.8327 3.93318 17.8327 3.23312 17.5602 2.69834C17.3205 2.22793 16.9381 1.84548 16.4677 1.6058C15.9329 1.33331 15.2328 1.33331 13.8327 1.33331H5.16602C3.76588 1.33331 3.06582 1.33331 2.53104 1.6058C2.06063 1.84548 1.67818 2.22793 1.4385 2.69834C1.16602 3.23312 1.16602 3.93318 1.16602 5.33331V10.6666C1.16602 12.0668 1.16602 12.7668 1.4385 13.3016C1.67818 13.772 2.06063 14.1545 2.53104 14.3942C3.06582 14.6666 3.76588 14.6666 5.16602 14.6666Z"
        stroke={stroke}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgLetterIcon
